import { connect, ConnectedProps } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import lang from '../../lib/language';
import { RootState } from '../../lib/store';
import { login as serviceLogin, logout as serviceLogout } from '../../lib/store/common-actions';

import ArrowBack from '../../assets/img/blue_icon-arrow-left.svg';
import SearchIconMobile from '../../assets/img/icon-search_24px.svg';
import SearchIcon from '../../assets/img/icon-search_white.svg';
import { useIsMobile } from '../../hooks';
import { getTabName } from '../../util/helpers';
import { UI_ROUTES } from '../../util/routes';
import { ClickableImage, Sidebar } from '../index';
import WelcomeSubscriptionPopup from '../WelcomeSubscriptionPopup/WelcomeSubscriptionPopup';

import HeaderDropdown from './HeaderDropdown/HeaderDropdown';
import { LogoutActionSelector } from './HeaderConstants';

import styles from './Header.module.scss';

type OwnProps = {
  isSearchActive: (val: boolean) => void;
};
type Props = OwnProps & ReduxProps;

const Header = (props: Props): JSX.Element => (
  <>
    <HeaderOriginal {...props} />
  </>
);

const HeaderOriginal = (props: Props) => {
  const { logout, login, isSearchActive } = props;
  const { isMobile } = useIsMobile();
  const location = useLocation();
  const navigate = useNavigate();

  const isShowSearchIcon = ([
    UI_ROUTES.earningsCalendar,
    UI_ROUTES.overview,
    UI_ROUTES.discover,
    UI_ROUTES.myAccount,
    UI_ROUTES.myProfile,
    UI_ROUTES.myPosition,
    UI_ROUTES.tradeHistory,
  ] as string[]).includes(location.pathname);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleLogout = () => {
    logout();
    login();
  };

  const returnBtn = () => (
    <button type="button" className={styles.returnBtn} onClick={handleGoBack}>
      <img src={ArrowBack} alt="Back" />
    </button>
  );

  const onSearchClickWeb = (): void => {
    isSearchActive(true);
  };

  const onSearchClickMob = () => {
    navigate(`${UI_ROUTES.searchSymbolsMob}`);
  };

  const handleHamburgerMenu = () => (
    <>
      <Sidebar isCapitalHamburger />
    </>
  );

  return (
    <>
      {isMobile ? (
        <div className={classNames(styles.containerMobile, {
          [styles.containerMobileCapital]: true,
        })}
        >
          <div className={styles.returnBtnMobile}>
            {getTabName(location) === 0 ? returnBtn() : handleHamburgerMenu()}
          </div>
          <div>
            <WelcomeSubscriptionPopup />
          </div>
          {isShowSearchIcon && (
            <div className={styles.buttonsMobile}>
              <div className={styles.searchBtnMobile}>
                <ClickableImage
                  src={SearchIconMobile}
                  alt="search"
                  className={styles.searchIcon}
                  onClick={onSearchClickMob}
                />
              </div>
              <div className={styles.notificationsMobile}>
                <HeaderDropdown isUserProfile={false} />
              </div>
            </div>
          )}
        </div>

      ) : (
        <>
          <div className={styles.container}>
            <div className={styles.contentWrapper}>
              <div className={styles.headerElements}>
                <div className={styles.headerProfileInfo}>
                  <div className={styles.settings}>
                    <HeaderDropdown isUserProfile={false} />
                  </div>
                  <div className={styles.userData}>
                    <HeaderDropdown
                      isUserProfile
                      actions={{
                        [LogoutActionSelector]: handleLogout,
                      }}
                    />
                  </div>
                </div>
                <div className={styles.searchStocksWrapper}>
                  <img src={SearchIcon} alt="search stocks" />
                  <input type="text" readOnly placeholder={lang.commonSearchForStocks()} onClick={onSearchClickWeb} />
                </div>
              </div>
              <div className={styles.hiddenHeader} />
            </div>
          </div>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = (dispatch: any, ownProps: any) => ({
  dispatch,
  logout: () => dispatch(serviceLogout()),
  login: () => {
    dispatch(serviceLogin('login'));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(Header);
